<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-06'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Emergency voice communication</h2>

                <p>Emergency services and public safety agencies depend on voice as a mission-critical application. 5G offers advanced features based on its ability to support end-to-end network slicing for assured performance. Service Level Agreements can encompass service reliability, availability and performance, allowing emergency services, businesses, and residential services to coexist on the same network infrastructure without compromising each other’s performance.</p>
                <p>Open programmability enables personalized emergency, content delivery and communication.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>